export const NotFound = 404
